
export function displayState(state:string)
{
	const states = {act:'ACT',nsw:'NSW',nt:'NT',qld:'Qld',sa:'SA',tas:'Tas',vic:'Vic',wa:'WA'};
	return states[state];
}

